import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllHotelExtras as restoreAllHotelExtrasAPI } from "../../api/apiHotelExtras";
import parseError from "../../utils/parseError";

const useRestoreAllHotelExtras = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAll, isPending: isRestoreAll } = useMutation({
        mutationFn: restoreAllHotelExtrasAPI,
        onSuccess: (res) => {
            const message = res?.message || "Selected hotel extras restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelExtras"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore selected hotel extras");
        },
    });

    return { restoreAllHotelExtras: restoreAll, isRestoreAll };
};

export default useRestoreAllHotelExtras;
